import { render, staticRenderFns } from "./jobURL.vue?vue&type=template&id=60a343d0"
import script from "./jobURL.vue?vue&type=script&lang=js"
export * from "./jobURL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports